/*global window, document*/

import countableInput from "../utils/countable-input";
import previousElementSiblings from "../utils/previous-element-siblings";

const isGuestQuestion = window.location.pathname.includes("additional_questions");

window.addEventListener("load", function () {
  const nextBtn = document.querySelector("[data-hys-survey-next-button]");
  const btnOriginalCopy = nextBtn.value;

  if (isGuestQuestion) {
    nextBtn.value = "Skip";
  }

  [...document.querySelectorAll(".step__text-area-choice-wrapper")].forEach(function (divElement) {
    const textAreaElement = divElement.querySelector("textarea");
    const outputElement = divElement.querySelector("p");
    countableInput(textAreaElement, outputElement, 300);
  });

  [...document.querySelectorAll(".survey-step__single-choices")].forEach(function (choicesWrapperElement) {
    const choiceElements = [...choicesWrapperElement.querySelectorAll(".survey-step__single-choice")];

    choiceElements.forEach(function (labelElement) {
      labelElement.addEventListener("click", function () {
        choiceElements.forEach(function (labelElement) {
          labelElement.classList.remove(labelElement.dataset.selectedClassName);
          labelElement.classList.remove("-selected");
        });

        labelElement.classList.add(labelElement.dataset.selectedClassName);
        labelElement.classList.add("-selected");

        nextBtnCheck();
      });
    });
  });

  [...document.querySelectorAll(".step__numeric-choices")].forEach(function (choicesWrapperElement) {
    const choiceElements = [...choicesWrapperElement.querySelectorAll(".step__numeric-choice")];

    choiceElements.forEach(function (labelElement) {
      labelElement.addEventListener("click", function () {
        choiceElements.forEach(function (labelElement) {
          labelElement.classList.remove(labelElement.dataset.class);
          labelElement.classList.remove("step__numeric-choice--selected");
        });

        labelElement.classList.add(labelElement.dataset.class);
        labelElement.classList.add("step__numeric-choice--selected");

        previousElementSiblings(labelElement).forEach(function (previousLabelElement) {
          previousLabelElement.classList.add(previousLabelElement.dataset.class);
        });

        nextBtnCheck();
      });
    });
  });

  [...document.querySelectorAll(".survey__multi-select")].forEach(function (choicesWrapperElement) {
    choicesWrapperElement.addEventListener('click', toggleSelectedClass);

    function toggleSelectedClass(e) {
      const checkbox = e.currentTarget.querySelector('input[type="checkbox"]');

      if (checkbox) {
        if (!checkbox.checked) {
          e.currentTarget.classList.toggle('-selected');
          nextBtnCheck();
        }
      }
    }
  });

  document.querySelectorAll(".survey-step__single-choice-additional-free-text").forEach(function (labelElement) {
    labelElement.addEventListener("click", function () {
      document.querySelectorAll(".step__text-area-choice-wrapper").forEach(function (textAreaWrapperElement) {
        const textAreaElement = textAreaWrapperElement.querySelector("textarea");
        textAreaElement.setAttribute("disabled", "disabled");

        textAreaWrapperElement.classList.add("-hidden");
      });

      const className = `.step__text-area-choice-wrapper${labelElement.dataset.selectedClassName}`;
      const textAreaContainerElement = document.querySelector(className);

      if (textAreaContainerElement) {
        const textAreaElement = textAreaContainerElement.querySelector("textarea");

        textAreaContainerElement.classList.remove("-hidden");
        textAreaElement.removeAttribute("disabled");
      }
    });
  });

  [...document.querySelectorAll("[data_hys_survey_textarea]")].forEach(function (choicesWrapperElement) {
    if (choicesWrapperElement.value.length) {
      nextBtn.value = btnOriginalCopy;
    }

    choicesWrapperElement.addEventListener('input', function () {
      if (choicesWrapperElement.value.length) {
        if (isGuestQuestion) {
          nextBtn.value = btnOriginalCopy;
        }
      } else {
        if (isGuestQuestion) {
          nextBtn.value = "Skip";
        }
      }
    });
  });

  if (isGuestQuestion) {
    const selectElements = [...document.querySelectorAll(".survey-step__dropdown")];
    if (selectElements.every((selectElement) => selectElement.value !== "")) {
      nextBtn.value = btnOriginalCopy;
    }

    selectElements.forEach((selectElement) => {
      selectElement.addEventListener("change", () => {
        if (selectElements.every((selectElement) => selectElement.value !== "")) {
          nextBtn.value = btnOriginalCopy;
        } else {
          nextBtn.value = "Skip";
        }
      })
    });
  }

  function nextBtnCheck(){
    const singleChoiceQuestions = [...document.querySelectorAll(".survey-step__single-choices")];
    const singleChoiceQuestionsCount = singleChoiceQuestions.length;
    let selectedCountForSingleChoice = 0;
    let isNextDisabledForSingleChoice = false;

    const numericChoiceQuestions = [...document.querySelectorAll(".step__numeric-choices")];
    const numericChoiceQuestionsCount = numericChoiceQuestions.length;
    let selectedCountForNumericChoice = 0;
    let isNextDisabledForNumericChoice = false;

    const multiSelectQuestions = [...document.querySelectorAll(".survey__multi-select-container")];
    const multiSelectQuestionsCount = multiSelectQuestions.length;
    let selectedCountForMultiSelectChoice = 0;
    let isNextDisabledForMultiSelectChoice = false;

    if (singleChoiceQuestionsCount > 0) {
      singleChoiceQuestions.forEach(function (choicesWrapperElement) {
        selectedCountForSingleChoice += [...choicesWrapperElement.querySelectorAll(".-selected")].length;
      });

      if (isGuestQuestion) {
        if (!(singleChoiceQuestionsCount === selectedCountForSingleChoice)) {
          nextBtn.value = "Skip";
        } else {
          nextBtn.value = btnOriginalCopy;
        }
      } else {
        isNextDisabledForSingleChoice = !(singleChoiceQuestionsCount === selectedCountForSingleChoice);
      }
    }

    if (numericChoiceQuestionsCount > 0) {
      numericChoiceQuestions.forEach(function (choicesWrapperElement) {
        selectedCountForNumericChoice += [...choicesWrapperElement.querySelectorAll( ".step__numeric-choice--selected")].length;
      });
     
      if (isGuestQuestion) {
        if (!(numericChoiceQuestionsCount === selectedCountForNumericChoice)) {
          nextBtn.value = "Skip";
        } else {
          nextBtn.value = btnOriginalCopy;
        }
      } else {
        isNextDisabledForNumericChoice = !(numericChoiceQuestionsCount === selectedCountForNumericChoice);
      }
    }

    if (multiSelectQuestionsCount > 0) {
      multiSelectQuestions.forEach(function (choicesWrapperElement) {
        selectedCountForMultiSelectChoice += [...choicesWrapperElement.querySelectorAll(".-selected")].length;
      });

      if (isGuestQuestion) {
        if (selectedCountForMultiSelectChoice === 0) {
          nextBtn.value = "Skip";
        } else {
          nextBtn.value = btnOriginalCopy;
        }
      } else {
        isNextDisabledForMultiSelectChoice = selectedCountForMultiSelectChoice === 0;
      }
    }

    if (isNextDisabledForSingleChoice || isNextDisabledForNumericChoice || isNextDisabledForMultiSelectChoice) {
      nextBtn.classList.add("-disabled");
    } else {
      nextBtn.classList.remove("-disabled");
    }
  }

  nextBtnCheck();
});
